module.exports = __webpack_public_path__ + "img/l_ha.c03eb9a9.png";